// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"779": "fca542fd80e0d882","989": "df2d1de54d3b9b2c",}[chunkId] + ".chunk.css"
}